/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Model, ModelMixin} from '../../../../common/model.class';
import * as moment from 'moment';
import Moment = moment.Moment;

export class AbmsBoardSubspecialty extends ModelMixin() implements Model<AbmsBoardSubspecialty> {

    TYPE = AbmsBoardSubspecialty;

    certificate?: string;
    currentlyCertified?: boolean;
    certificationDate?: Moment;
    recertified?: boolean;
    recertificationDate?: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.certificationDate) jsonData.certificationDate = moment(jsonData.certificationDate);
        if (jsonData.recertificationDate) jsonData.recertificationDate = moment(jsonData.recertificationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.model.ts